export default {
  TOGGLE_USER_MENU: state => {
    state.isUserMenuOpened = !state.isUserMenuOpened;
  },
  SET_ALERT_BAR: (state, config) => {
    state.alertBar = { ...state.alertBar, ...config };
  },
};
